.form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 12px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.input {
  background-color: #2d2d2d;
  border: 1px solid #4a4a4a;
  border-radius: 8px;
  padding: 10px 12px;
  color: #fff;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s;
}

.input:focus {
  outline: none;
  border-color: #10b981;
  background-color: #333;
}

.input::placeholder {
  color: #666;
}

.iconGrid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.iconButton {
  aspect-ratio: 1;
  background-color: #2d2d2d;
  border: 2px solid #4a4a4a;
  border-radius: 8px;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconButton:hover {
  background-color: #3d3d3d;
  border-color: #5a5a5a;
  transform: scale(1.05);
}

.iconButton.selected {
  background-color: #10b981;
  border-color: #10b981;
}

.preview {
  background-color: #0d0d0d;
  border: 1px solid #4a4a4a;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.previewLabel {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.previewCounter {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background-color: #2d2d2d;
  border: 1px solid #4a4a4a;
  border-radius: 8px;
}

.previewIcon {
  font-size: 20px;
  width: 28px;
  text-align: center;
}

.previewTitle {
  font-size: 12px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex: 1;
}

.previewValue {
  font-size: 20px;
  font-weight: bold;
  color: #10b981;
  font-family: 'Courier New', monospace;
}

.actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.cancelButton,
.addButton {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.cancelButton {
  background-color: #2d2d2d;
  color: #fff;
  border: 1px solid #4a4a4a;
}

.cancelButton:hover {
  background-color: #3d3d3d;
}

.addButton {
  background-color: #10b981;
  color: #fff;
}

.addButton:hover {
  background-color: #059669;
}

.addButton:disabled {
  background-color: #4a4a4a;
  color: #666;
  cursor: not-allowed;
}